"use client";

import Link from "next/link";
import Image from "next/image";
import { motion } from "framer-motion";
import EnrollButton from "@/components/LeadForm/EnrollButton";
import { FORM_CONTEXTS } from "@/utils/innovlistWidget";

export function Banner() {
    return (
        <section className="py-12 bg-white">
            <div className="max-w-[1440px] mx-auto px-4 md:px-8 lg:px-12">
                <motion.div
                    initial={{ opacity: 0, scale: 0.98 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="bg-[#0A268D] rounded-[2rem] overflow-hidden relative min-h-[500px] flex flex-col lg:flex-row items-center"
                >
                    {/* Decorative Dots Top Right for Image */}
                    <div className="absolute right-[15%] top-12 hidden lg:block opacity-40">
                        <div className="grid grid-cols-6 gap-2">
                            {[...Array(24)].map((_, i) => (
                                <div key={i} className="w-1 h-1 bg-white/60 rounded-full"></div>
                            ))}
                        </div>
                    </div>

                    {/* Left Content */}
                    <motion.div
                        initial={{ opacity: 0, x: -30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.2, duration: 0.6 }}
                        className="flex-1 p-8 md:p-12 lg:p-16 z-10"
                    >
                        <h2 className="text-white text-3xl lg:text-4xl font-bold mb-4 leading-tight">
                            Transform Your Career for the<br className="hidden md:block" /> Digital Era
                        </h2>
                        <p className="text-white/90 text-[18px] mb-8 max-w-xl">
                            Stay ahead with industry-relevant skills, expert-led training, and<br className="hidden md:block" /> practical learning paths designed for real-world success.
                        </p>

                        <ul className="space-y-4 mb-10">
                            {[
                                "Learn in-demand tech skills",
                                "Prepare for certifications & interviews",
                                "Get career guidance & placement support",
                                "Upskill at your own pace"
                            ].map((item, idx) => (
                                <motion.li
                                    key={idx}
                                    initial={{ opacity: 0, x: -10 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: 0.4 + idx * 0.1 }}
                                    className="flex items-center gap-3 text-white text-[14px] md:text-base"
                                >
                                    <div className="w-1.5 h-1.5 bg-blue-400 rounded-full"></div>
                                    {item}
                                </motion.li>
                            ))}
                        </ul>

                        <div className="mt-8">
                            <EnrollButton
                                label="Enroll Now"
                                variant="primary"
                                size="lg"
                                context={FORM_CONTEXTS.ENROLL_NOW}
                            />
                        </div>

                        <p className="mt-12 text-white/60 font-bold text-[11px] tracking-widest uppercase">
                            *STARTING FROM AFFORDABLE PRICING
                        </p>
                    </motion.div>

                    {/* Right Content - Circular Image */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.3, duration: 0.8 }}
                        className="flex-1 flex justify-center lg:justify-end items-center p-8 lg:p-16 relative"
                    >
                        <div className="relative w-[300px] h-[300px] md:w-[400px] md:h-[400px] lg:w-[450px] lg:h-[450px]">
                            {/* Decorative Dots Bottom Right */}
                            <div className="absolute -right-8 -bottom-8 hidden lg:block opacity-40">
                                <div className="grid grid-cols-5 gap-1.5">
                                    {[...Array(15)].map((_, i) => (
                                        <div key={i} className="w-1 h-1 bg-white/60 rounded-full"></div>
                                    ))}
                                </div>
                            </div>

                            <div className="relative w-full h-full rounded-full overflow-hidden border-8 border-white/10 shadow-2xl">
                                <Image
                                    src="/images/circle-img.jpg"
                                    alt="Digital Education"
                                    fill
                                    className="object-cover"
                                    priority
                                />
                            </div>
                        </div>
                    </motion.div>
                </motion.div>
            </div>
        </section>
    );
}

